import Vue from "vue";
import {
  Vuetify,
  VApp,
  VAlert,
  VAutocomplete,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  VForm,
  VTextarea,
  VTextField,
  VCard,
  VImg,
  VMenu,
  VSelect,
  VDivider,
  VDataTable,
  VProgressCircular,
  VDialog,
  VDatePicker,
  VSpeedDial,
  VTooltip,
  VExpansionPanel,
  VBadge,
  VTabs,
  VPagination,
  VSnackbar,
  transitions
} from "vuetify";
import "vuetify/src/stylus/app.styl";

Vue.use(Vuetify, {
  components: {
    VApp,
    VAlert,
    VAutocomplete,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    VForm,
    VTextarea,
    VTextField,
    VCard,
    VImg,
    VMenu,
    VSelect,
    VDivider,
    VDataTable,
    VProgressCircular,
    VDialog,
    VDatePicker,
    VSpeedDial,
    VTooltip,
    VExpansionPanel,
    VBadge,
    VTabs,
    VPagination,
    VSnackbar,
    transitions
  },
  theme: {
    primary: "#E77A16",
    secondary: "#424242",
    accent: "#82B1FF",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FFC107"
  },
  customProperties: true,
  iconfont: "md"
});
